import React from 'react';
import CloudUploadIcon from '@mui/icons-material//CloudUpload';
import { Box, CircularProgress } from '@mui/material';
import theme from 'theme';
import { CircularArrowUpLoaderProps } from './CircularArrowUpLoader.props';

const CircularArrowUpLoader = ({ arrowUpwardIconClass }: CircularArrowUpLoaderProps) => (
  <Box sx={{ position: 'relative', display: 'inline-flex' }}>
    <CircularProgress
      size="5.5rem"
      style={{
        backgroundColor: theme.palette.grey[100],
        borderRadius: '50%',
        color: theme.palette.secondary[600],
      }}
      thickness={2}
    />
    <Box
      style={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <CloudUploadIcon className={arrowUpwardIconClass} />
    </Box>
  </Box>
);

export default CircularArrowUpLoader;
